module.exports = __webpack_public_path__ + "static/media/Microsoft.ffc39dc2.png";